/**
 * Parses acceptedTypes string (e.g. ".pdf,.doc,.docx") into a Set of lowercase extensions.
 * Used to validate file types on drop, since the accept attribute only affects the file picker.
 */
export const parseAcceptedExtensions = (acceptedTypes) => {
	if (!acceptedTypes || typeof acceptedTypes !== 'string') return new Set();
	return new Set(
		acceptedTypes
			.split(',')
			.map((t) => t.trim().toLowerCase())
			.filter((t) => t.startsWith('.'))
	);
};

export const isFileTypeAccepted = (file, acceptedTypesStr) => {
	const allowed = parseAcceptedExtensions(acceptedTypesStr);
	if (allowed.size === 0) return true;
	const name = file.name || '';
	const lastDot = name.lastIndexOf('.');
	const ext = lastDot >= 0 ? `.${name.slice(lastDot + 1).toLowerCase()}` : '';
	return allowed.has(ext);
};

/**
 * Formats acceptedTypes for display (e.g. ".pdf,.doc,.docx" -> "PDF, DOC, DOCX").
 */
export const formatAcceptedTypesForDisplay = (acceptedTypes) => {
	const exts = parseAcceptedExtensions(acceptedTypes);
	if (exts.size === 0) return '';
	return [...exts].map((ext) => ext.slice(1).toUpperCase()).join(', ');
};
